import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { from, map, mergeMap, Observable, of } from 'rxjs';
import { RouteTranslateService } from 'src/app/common/route-translate/route-translate.service';
import { UserService } from 'src/app/common/user/user.service';
import { MaintenanceSiteGQL } from './maintenance.query.generated';
import { UserRole } from 'src/types/graphql';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard {
  constructor(
    private router: Router,
    private maintenanceSiteGQL: MaintenanceSiteGQL,
    private routeTranslateService: RouteTranslateService,
    private userService: UserService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.inMaintenance().pipe(
      map(({ deprecate, maintenance }) => {
        if (!deprecate && !maintenance) {
          this.router.navigate([this.routeTranslateService.translateRoute('explore')]);
          return false;
        }
        if (deprecate && route.routeConfig.path === 'maintenance') {
          this.router.navigate(['/deprecated']);
        }
        if (maintenance && !deprecate && route.routeConfig.path === 'deprecated') {
          this.router.navigate(['/maintenance']);
        }
        return true;
      }),
    );
  }

  inMaintenance() {
    return (Capacitor.isNativePlatform() ? from(App.getInfo()) : of({ name: '', id: '', build: '', version: '' })).pipe(
      mergeMap(({ version }) =>
        this.maintenanceSiteGQL.fetch({ platform: Capacitor.getPlatform(), version }, { fetchPolicy: 'no-cache' }),
      ),
      map(r => {
        if (this.userService?.user?.role !== UserRole.Admin) {
          return r.data.maintenanceSite;
        } else {
          return { maintenance: false, deprecate: false };
        }
      }),
      // map(() => ({ maintenance: true, deprecate: false })),
    );
  }
}
